import React, { useState } from 'react';

import {
  Collapse,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@material-ui/core';

import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ListAltIcon from '@material-ui/icons/ListAlt';
import InfoIcon from '@material-ui/icons/Info';

import translations from '../../../languages/i18n';

import programConfigurationStyles from '../../../styles/programConfigurationStyles';

import PropTypes from 'prop-types';

export default function FormDetailsTechnical({programConfiguration, formIdentificator, handleShowVariables}) {
  const classesProgConfig = programConfigurationStyles();

  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  // Agafam l'objecte que es correspon al formulari
  const formProperties = programConfiguration.forms.find((form)=> form.name === formIdentificator);
  // Si no es troba l'objecte, no es mostra res
  if (formProperties) {
    return (
      <List>
        <ListItem button onClick={handleClick}>
          <ListItemIcon><ListAltIcon /></ListItemIcon>
          <ListItemText primary={formIdentificator} />
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List disablePadding>
            <ListItem className={classesProgConfig.nestedItem}>
              <ListItemText primary={translations['_fillInAt']} />
              <Typography component='span' variant="body2" color="textPrimary" className={classesProgConfig.collapsedText}>{formProperties.managedBy.toString()}</Typography>
            </ListItem>
            <Divider />
            <ListItem className={classesProgConfig.nestedItem}>
              <ListItemText primary={translations['_fromInfo']} />
                <Typography component='span' variant="body2" color="textPrimary" className={classesProgConfig.collapsedText}>{formProperties.from.toString()}</Typography>
            </ListItem>
            <Divider />
            <ListItem className={classesProgConfig.nestedItem}>
              <ListItemText primary={translations['_daysToFillIn']} />
                <Typography component='span' variant="body2" color="textPrimary" className={classesProgConfig.collapsedText}>{formProperties.daysToFillIn}</Typography>
            </ListItem>
            <Divider />
            <ListItem className={classesProgConfig.nestedItem}>
              <ListItemText primary={translations['_fillInBy']} />
                <Typography component='span' variant="body2" color="textPrimary" className={classesProgConfig.collapsedText}>{formProperties.user}</Typography>
            </ListItem>            
            {formProperties.repeat && (
              <React.Fragment>
                <Divider />
                <ListItem className={classesProgConfig.nestedItem}>
                  <ListItemText primary={translations['_repetition']} />
                </ListItem>
                <ListItem className={classesProgConfig.nestedItem}>
                  <ListItemText className={classesProgConfig.nestedItem} primary={translations['_fromInfo']} />
                  <Typography component='span' variant="body2" color="textPrimary" className={classesProgConfig.collapsedRepeatText}>{formProperties.repeatFrom.toString()}</Typography>
                </ListItem>
                <ListItem className={classesProgConfig.nestedItem}>
                  <ListItemText className={classesProgConfig.nestedItem} primary={translations['_repeatFrequency']} />
                  <Typography component='span' variant="body2" color="textPrimary" className={classesProgConfig.collapsedRepeatText}>{formProperties.repeatFrequency.toString()}</Typography>
                </ListItem>
                <ListItem className={classesProgConfig.nestedItem}>
                  <ListItemText className={classesProgConfig.nestedItem} primary={translations['_repeatTimes']} />
                  <Typography component='span' variant="body2" color="textPrimary" className={classesProgConfig.collapsedRepeatText}>{formProperties.repeatTimes}</Typography>                  
                </ListItem> 
              </React.Fragment>
            )}
            {formProperties.user === 'Patient' && (
              <React.Fragment>
                <Divider />
                <ListItem className={classesProgConfig.nestedItem} button onClick={() => handleShowVariables(formProperties.name)}>
                  <ListItemIcon><InfoIcon /></ListItemIcon>
                  <ListItemText primary={translations['_viewVariables']} />
                </ListItem>
              </React.Fragment>
            )}
          </List>
        </Collapse>
      </List>
      )
    } else {
      return null
    }
}

// Indica i controla els props que se han de passar al component
FormDetailsTechnical.propTypes = {
  formIdentificator: PropTypes.string.isRequired,
  handleShowVariables: PropTypes.func.isRequired,
  programConfiguration: PropTypes.object.isRequired
};
